import React, { type FC } from "react";
import { type SwitchButtonProps } from "./SwitchButton.interface";
import ReactSwitch from "react-switch";

export const SwitchButton: FC<SwitchButtonProps> = ({
  onChange,
  checked,
  className,
  disabled,
}) => {
  const handleChange = (
    nextChecked: boolean,
    event: React.SyntheticEvent<MouseEvent | KeyboardEvent> | MouseEvent
  ) => {
    event.preventDefault();
    event.stopPropagation();
    onChange(nextChecked, event);
  };
  return (
    <ReactSwitch
      className={className}
      onColor="#2CD19E"
      height={18}
      width={40}
      disabled={disabled}
      handleDiameter={15}
      uncheckedIcon={false}
      checkedIcon={false}
      onChange={handleChange}
      checked={checked}
    />
  );
};
